// Description, read more
(() => {
  const readMoreButton = document.querySelector(
    ".product__description-read-more button"
  );
  const descriptionBlock = document.querySelector(
    '.product-info__block-item[data-block-type="description"]'
  );
  const descriptionHolder = document.querySelector(
    '.product-info__block-item[data-block-type="description"] > .prose.relative'
  );

  if (!readMoreButton || !descriptionHolder) {
    return;
  }

  descriptionHolder.style.height = "auto";
  descriptionHolder.dataset.fullHeight = `${descriptionHolder.clientHeight}px`;

  const collapsedHeight = `${
    descriptionHolder.clientHeight >= 175
      ? 175
      : descriptionHolder.clientHeight * 0.65
  }px`;
  descriptionHolder.style.height = collapsedHeight;

  function toggleDescription(evt) {
    switch (readMoreButton.textContent) {
      case "Read More":
        descriptionBlock.setAttribute("aria-expanded", "true");
        descriptionHolder.style.height = descriptionHolder.dataset.fullHeight;
        readMoreButton.textContent = "See Less";
        break;
      default:
        descriptionBlock.removeAttribute("aria-expanded", "false");
        descriptionHolder.style.height = collapsedHeight;
        readMoreButton.textContent = "Read More";
    }
  }

  readMoreButton.addEventListener("click", toggleDescription);
})();

/* Update buy button price */
/* Update buy button price and custom text */
(() => {
  const section = document.querySelector(".shopify-section--main-product");

  if (!section) return;

  function updateButtonText(evt) {
    const button = section.querySelector(
      '.product-info__block-item[data-block-type="buy-buttons"] .button[type="submit"]'
    );

    const buyButtons = section.querySelector(
      'buy-buttons[data-button-type]'
    );

    if (!button || !buyButtons || !evt.detail.variant) return;

    const variantPrice = evt.detail.variant.price / 100;
    const buttonType = buyButtons.dataset.buttonType;

    let buttonText = "Add to bag";

    if (buttonType === "lesson") {
      buttonText = "BOOK YOUR LESSON";
    } else if (buttonType === "enroll") {
      buttonText = "ENROLL NOW";
    }

    button.textContent = `$${variantPrice.toFixed(2)} • ${buttonText}`;
  }

  section.addEventListener("variant:change", updateButtonText);
})();

// Back in Stock
(() => {
  const section = document.querySelector(".shopify-section--main-product");
  const buyButtons = section.querySelector("buy-buttons");

  buyButtons.id = "mainFormAddToCart";

  var klaviyo = window.klaviyo || [];

  klaviyo.init({
    account: "Ttx6Zp",
    platform: "shopify",
  });

  klaviyo.enable("backinstock", {
    trigger: {
      product_page_text: "Notify Me When Available",
      product_page_class: "button",
      product_page_text_align: "center",
      product_page_margin: "0px",
      product_page_width: "100%",
      alternate_anchor: "mainFormAddToCart",
      replace_sold_out: false,
    },
    modal: {
      headline: "{product_name}",
      body_content:
        "Register to receive a notification when this item comes back in stock.",
      email_field_label: "Email",
      button_label: "Notify me when available",
      subscription_success_label:
        "You're in! We'll let you know when it's back.",
      footer_content: "",
      drop_background_color: "#000",
      background_color: "#fff",
      text_color: "#757575",
      button_text_color: "#fff",
      button_background_color: "#172337",
      close_button_color: "#c5c5c5",
      error_background_color: "#eb001b",
      error_text_color: "#fff",
      success_background_color: "#d3efcd",
      success_text_color: "#1B9500",
    },
  });
})();

// Sticky
(() => {
  const stickyBar = document.querySelector(".product-sticky-bar");

  if (!stickyBar) {
    return;
  }

  function toggle(entries) {
    const buyButtonsEntry = entries.find((entry) =>
      entry.target.matches(".shopify-section--main-product .buy-buttons")
    );

    if (!buyButtonsEntry) {
      return;
    }

    const isBuyButtonsVisible =
      buyButtonsEntry.isIntersecting ||
      buyButtonsEntry.boundingClientRect.bottom > 0;
    stickyBar.classList.toggle("is-visible", !isBuyButtonsVisible);
  }

  const observer = new IntersectionObserver(toggle);
  observer.observe(
    document.querySelector(".shopify-section--main-product .buy-buttons")
  );
})();
